import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Network } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const ROLES = [
    'Maintenance contractors',
    'Industrial painters',
    'Facility management companies',
    'Equipment suppliers',
    'General contractors',
    'Restoration companies',
];

const Referrals = () => {
    useSEO({
        title: 'Industrial Service Network — Dry Ice Bulls Cleaning System®',
        description: 'Join the Dry Ice Bulls Cleaning System® Industrial Service Network. For maintenance contractors, industrial painters, facility managers, and general contractors.',
    });

    return (
        <div className="pt-24 pb-24" data-testid="referrals-page">
            <div className="container-page">
                <div className="label-caps text-brand-primary mb-4">/ Industrial Service Network</div>
                <h1 className="font-display font-black uppercase text-5xl md:text-7xl leading-[0.95] text-neutral-900">
                    Extra capability<br /><span className="text-brand-primary">when you need it.</span>
                </h1>
                <p className="mt-6 max-w-3xl text-base md:text-lg text-neutral-600 leading-relaxed">
                    Our Industrial Service Network connects Dry Ice Bulls Cleaning System® with trusted partners who can add cleaning technology to their offering — or refer jobs when they need our specialized equipment on site.
                </p>

                <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-10">
                    <div className="lg:col-span-7">
                        <div className="label-caps text-brand-primary mb-3 text-xs">/ Who joins</div>
                        <h2 className="font-display font-black uppercase text-3xl md:text-4xl text-neutral-900 leading-tight">
                            The right fit.
                        </h2>
                        <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {ROLES.map((r) => (
                                <li key={r} className="border border-neutral-200 bg-white px-4 py-3 text-sm text-neutral-800 flex items-center gap-2">
                                    <Network className="h-4 w-4 text-brand-primary shrink-0" /> {r}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="lg:col-span-5">
                        <div className="border border-neutral-200 bg-neutral-50 p-8">
                            <div className="label-caps text-brand-primary text-xs mb-3">/ How it works</div>
                            <ol className="space-y-4 text-sm text-neutral-700">
                                <li><span className="font-display font-bold text-neutral-900 block">1. Apply</span> Tell us about your company and typical projects.</li>
                                <li><span className="font-display font-bold text-neutral-900 block">2. Verify</span> Quick vetting call — insurance, safety, references.</li>
                                <li><span className="font-display font-bold text-neutral-900 block">3. Refer or subcontract</span> Send jobs our way when you need our tech, or take our cleaning-only jobs when we need extra hands.</li>
                            </ol>
                            <div className="mt-6">
                                <Link
                                    to="/contact?subject=Industrial+Service+Network+Application"
                                    className="inline-flex items-center gap-2 bg-brand-primary hover:bg-brand-primaryHover text-white font-bold px-5 py-3 label-caps transition-colors"
                                    data-testid="referrals-cta"
                                >
                                    Apply to Network <ArrowRight className="h-4 w-4" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Referrals;
